import type { VoteEditionVoterExportResponse } from '@api/votes-api';

function escapeCsvValue(value: string): string {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function buildEditionVotersCsv(voters: readonly VoteEditionVoterExportResponse[]): string {
  const lines = voters.map((voter) =>
    [voter.docplannerId ?? '', voter.email].map(escapeCsvValue).join(','),
  );

  return ['docplannerId,email', ...lines].join('\n');
}

export function getEditionVotersCsvFilename(editionId: string, editionYear?: number): string {
  return editionYear != null
    ? `edition-voters-${editionYear}.csv`
    : `edition-${editionId}-voters.csv`;
}
